import React, { FC, useState } from 'react'
import { Grid } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux';

import { ProductCard } from '../ProductCard'
import SnackBarAlert from '../Alerts/AlertComponent';

import { ProductModel } from '../../models/product-model'
import { addToCart } from '../../flux/actions/shoppingCart-actions';

const FeaturedProducts: FC = () => {
    const dispatch = useDispatch();

    const productDetails = useSelector((state: any) => state.productReducer);
    const [isProductInCart, setIsProductInCart] = useState(false);
    const [isProductAdded, setIsProductAdded] = useState(false);
    let { featuredProducts = [] } = productDetails;
    const cart = useSelector((state: any) => state.cart);
    const { cartItems } = cart;

    const addToCartHandler = (id: string) => {
        let productInCart = cartItems.some((item:any) => item.id === id);
        if (!productInCart) {
            dispatch(addToCart(id, 1));
            setIsProductAdded(true);
        } else {
            setIsProductInCart(true);
        }
    }

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        setIsProductInCart(false);
        setIsProductAdded(false);
    };
    
    return (
        <>
            <Grid container spacing={3}>
                {isProductInCart && <SnackBarAlert severity='info' message='Este producto ya fue agregado, modifica la cantidad en tu carrito!' open={isProductInCart} onClose={handleClose}/>}
                <SnackBarAlert severity='success' message='Se ha agregado un producto al carrito' open={isProductAdded} onClose={handleClose}/>
                {
                    featuredProducts.map(
                        (product: ProductModel) => 
                        <Grid item sm={6} md={4} lg={4} xs={12}>
                            <ProductCard {...product} addToCartHandler={addToCartHandler} hideDescription key={product._id}/>
                        </Grid>
                    )
                }
            </Grid>
        </>
    );
}

export default FeaturedProducts;
